import { hexToRgba } from '@chronosphereio/core';
import { Components, stepIconClasses, Theme } from '@mui/material';
import { black, green, grey, white } from '../palette/colors';

export const MuiStepContent: Components<Theme>['MuiStepContent'] = {
  styleOverrides: {
    root: ({ theme }) => {
      const connectorColor = theme.featureFlags.panwRebrandStubYear ? theme.palette.border.bold : grey[400];
      return {
        borderColor: connectorColor,
      };
    },
  },
};

export const MuiStepIcon: Components<Theme>['MuiStepIcon'] = {
  styleOverrides: {
    root: ({ theme }) => {
      const panwRebrand = theme.featureFlags.panwRebrandStubYear;
      const isLight = theme.palette.mode === 'light';

      const iconBackground = panwRebrand ? theme.palette.interactive.neutral.default : isLight ? grey[300] : grey[500];
      const activeIconBackground = panwRebrand ? theme.palette.background.highlight : isLight ? green[600] : green[500];
      const activeIconColor = panwRebrand ? theme.palette.text.contrast : isLight ? white : hexToRgba(black, 0.87);

      return {
        color: iconBackground,

        [`&.${stepIconClasses.active},&.${stepIconClasses.completed}`]: {
          color: activeIconBackground,

          [`.${stepIconClasses.text}`]: {
            fill: activeIconColor,
          },
        },
        [`&.${stepIconClasses.completed}`]: {
          // The checkbox icon gets its color from the background, so we need to change the background to modify it.
          background: activeIconColor,
          // Force border radius, so that the background doesn't show outside the circle.
          borderRadius: '100%',
        },
      };
    },
    text: ({ theme }) => {
      const panwRebrand = theme.featureFlags.panwRebrandStubYear;
      const isLight = theme.palette.mode === 'light';

      const iconColor = panwRebrand ? theme.palette.background.inverse : isLight ? white : hexToRgba(black, 0.87);

      return {
        fill: iconColor,
        fontWeight: panwRebrand ? theme.typography.fontWeightBold : undefined,
      };
    },
  },
};

export const MuiStepConnector: Components<Theme>['MuiStepConnector'] = {
  styleOverrides: {
    line: ({ theme }) => {
      const connectorColor = theme.featureFlags.panwRebrandStubYear ? theme.palette.border.bold : grey[400];
      return {
        borderColor: connectorColor,
      };
    },
  },
};
